import { Dispatch } from 'redux';
import { GamesAction, ReduxGamesActionType } from './model';
import {
  fetchGameList,
  getGameFavoriteTotal,
  getServiceMyFavorite,
} from '../../../api/game';
import { fetchEnvCollectionList } from '../../../api/game/env';

// 获取游戏列表
export const getGameList = (dispatch: Dispatch<GamesAction>) => async () => {
  const res = await fetchGameList();
  if (res) {
    dispatch({
      type: ReduxGamesActionType.GET_GAMES,
      result: res,
    });
  }
};

// 获取环境列表
export const getEnvCollectionList =
  (dispatch: Dispatch<GamesAction>) => async (studioID: string) => {
    const res = await fetchEnvCollectionList(studioID);
    if (res) {
      dispatch({
        type: ReduxGamesActionType.ALL_ENV_LIST,
        result: res,
      });
    }
    return res;
  };

// 获取游戏服务收藏列表
export const getServiceMyFavoriteListAction = (
  dispatch: Dispatch<GamesAction>,
  gameID: string
) => {
  return async () => {
    const res = await getServiceMyFavorite(gameID);
    if (res) {
      dispatch({
        type: 'MyFavorite',
        result: res,
      });
    }
  };
};

export const getGameFavoriteTotalAction = (dispatch: Dispatch<GamesAction>) => {
  return async () => {
    const res = await getGameFavoriteTotal();
    if (res) {
      dispatch({
        type: 'ServiceFavoriteTotal',
        result: res,
      });
    }
  };
};
